import * as React from 'react';
import { TotalStatusHeader } from 'components/total-status-header';
import { HeaderStatusBar } from './HeaderStatusBar';
import { formatValueIfNullOrUndefined} from 'utilities/util';
import { IDivisionBreakdown } from 'views/job-costing/utils/CostAndRevenueHelpers';

interface IParams {
    firstValue?: any,
    firstValueLabel?:string
    secondValue?: any,
    secondValueLabel?:string,
    thirdValue?:any,
    thirdValueLabel?:string,
    forthValue?: any,
    forthValueLabel?: string,
    fifthValue?: any,
    fifthValueLabel?: string,
    statusColor?:string,
    target?:number,
    totals:{
        firstRow:{
            label: string,
            value: string,
            actualValue?: string
        },
        secondRow:{
            label: string,
            value: string,
            actualValue?: string
        },
        lastRow: {
            label: string,
            value?: string
        },
        isNftpRoeEnabled?: boolean,
        breakdown?: IDivisionBreakdown
    }
}
export const HeaderWrapper: React.FunctionComponent<IParams> = (props:IParams) => {
    return (
    
    <div className="grid-wrapper header-top-margin">
        <div className="col-70 vBottom">
            <HeaderStatusBar 
                firstValue={formatValueIfNullOrUndefined(props.firstValue)}
                secondValue={formatValueIfNullOrUndefined(props.secondValue)}
                thirdValue={formatValueIfNullOrUndefined(props.thirdValue)}
                forthValue={props.forthValue}
                fifthValue={props.fifthValue}
                firstValueLabel={props.firstValueLabel}
                secondValueLabel={props.secondValueLabel}
                thirdValueLabel={props.thirdValueLabel}
                forthValueLabel={props.forthValueLabel} 
                fifthValueLabel={props.fifthValueLabel}
                statusColor={props.statusColor}
                target={props.target}
            />
        </div>
        <div className="col-30">
            <TotalStatusHeader 
                {...props.totals}
            />
        </div>
    </div>
    );
}